<template>
  <div class="userinfo botPage">
    <mbHeader :title="$t('account_information')" :left="true" :lang="true"></mbHeader>
    <accountInfoNew></accountInfoNew>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import accountInfoNew from '../Profile/accountInfoNew';

export default {
  name: "mobileUserinfo",
  components: {mbHeader,accountInfoNew},
}
</script>

<style scoped lang="less">
.userinfo {
  min-height: 100vh;
  padding: 66px 16px 32px;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileUserinfo.vue